import { Box, Skeleton, Typography, useMediaQuery } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useCreditsAndPlans } from './context'

export default function RemainingTasks({ ...props }) {
    const { t } = useTranslation()
    const { downMd, remainingTasks, remainingTasksLoading, isSubscribeToPlan, isThirdPartyMerchant } = useCreditsAndPlans()

    return (
        <Box {...props} display={isSubscribeToPlan ? "block" : "none"}>
            <Box display="flex" alignItems='center' gap={1}>
                <Typography variant={downMd ? "h4" : "body2"} fontWeight="bold" color="white">
                    {`${t("Remaining Tasks")} : `}
                </Typography>
                {
                    remainingTasksLoading ?
                        <Skeleton variant="text" width={100} height={20} />
                        :
                        <Typography variant={downMd ? "h4" : "body2"} fontWeight="bold" color="white">
                            {`${remainingTasks}`}
                        </Typography>
                }
            </Box>
        </Box>
    )
}
